import { Worksheet } from 'exceljs';
import { Style, STYLES } from './project-exporting-config';

export const addTableHeaderRow = (ws: Worksheet, header: (null | { title?: string; style?: Style })[]): void => {
  const titles = header.map(t => t?.title);
  const row = ws.addRow(titles);
  row.eachCell((cell, idx) => {
    const { font = STYLES.whiteBoldFont, fill = STYLES.primaryTealFill } = header[idx - 1]?.style || {};
    cell.font = font;
    cell.fill = fill;
  });
};
